module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"bestsellers":"Хиты продаж","newArrivals":"Новые поступления","promotions":"Акции"},"uk":{"bestsellers":"Хіти продажів","newArrivals":"Нові надходження","promotions":"Акції"}}')
  delete Component.options._Ctor
}
